export const RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST = 'RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST';
export const RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE = 'RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE';
export const GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS = 'GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS';
export const GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_TAKA_NO = 'GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_TAKA_NO';
